import { render, staticRenderFns } from "./AppFormQuestion.vue?vue&type=template&id=02b6a38f&scoped=true"
import script from "./AppFormQuestion.vue?vue&type=script&lang=js"
export * from "./AppFormQuestion.vue?vue&type=script&lang=js"
import style0 from "./AppFormQuestion.vue?vue&type=style&index=0&id=02b6a38f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b6a38f",
  null
  
)

export default component.exports